import { Chip } from '@elementary/common-ui/components';
import { GPGKey, GPGKeyStatus } from '../types';

const getStatusFromKey = (gpgKey: GPGKey): 'success' | 'idle' | 'default' => {
  if (gpgKey.isActive) return 'success';
  if (gpgKey.status === GPGKeyStatus.revoked) return 'default';
  if (gpgKey.status === GPGKeyStatus.expired) return 'default';
  return 'idle';
};

const getStatusLabel = (gpgKey: GPGKey): string => {
  if (gpgKey.isActive) return 'Active';
  if (gpgKey.status === GPGKeyStatus.revoked) return 'Revoked';
  if (gpgKey.status === GPGKeyStatus.expired) return 'Expired';
  return 'Inactive';
};

const GPGKeyStatusChip = ({ gpgKey }: { gpgKey: GPGKey }) => (
  <Chip
    color={getStatusFromKey(gpgKey)}
    label={getStatusLabel(gpgKey)}
    size="small"
  />
);

export default GPGKeyStatusChip;
